export const YEAR_RECAP_FLAG = 'AHA-48191-release-recap-2026'

export const YEAR_RECAP_ROUTE_NAME = 'YearRecap'
export const YEAR_RECAP_ROUTE_PATH = '/recap/:year(\\d{4})'
export const YEAR_RECAP_PUBLIC_ROUTE_NAME = 'YearRecapPublic'
export const YEAR_RECAP_PUBLIC_ROUTE_PATH = '/recap/shared/:token'

export const YEAR_RECAP_EVENTS = {
  VIEW: 'Recap > View',
  SHARE_CLICK: 'Recap > Share Click',
  CREATE_PUBLIC_LINK: 'Recap > Create Public Link',
  REVOKE_PUBLIC_LINK: 'Recap > Revoke Public Link',
  SLIDE_VIEWED: 'Recap > Slide Viewed',
  SUMMARY_REACHED: 'Recap > Summary Reached',
  STORY_COMPLETED: 'Recap > Story Completed',
  SHARE_INTENT: 'Recap > Share Intent',
  PLATFORM_SELECTED: 'Recap > Platform Selected',
  SHARE_COPY_GENERATED: 'Recap > Share Copy Generated',
  COPY_POST_TEXT: 'Recap > Copy Post Text',
  DOWNLOAD_VISUAL: 'Recap > Download Visual',
  SHARE_OPENED: 'Recap > Share Opened',
  SUMMARY_CTA_CLICK: 'Recap > Summary CTA Click',
}

export const SLIDE_KEY = {
  PERSONA: 'persona',
  SESSIONS: 'sessions',
  PEOPLE: 'people',
  INTERACTIONS: 'interactions',
  PARTICIPATION_RATE: 'participation_rate',
  INTERACTIVE_SLIDES_CREATED: 'interactive_slides_created',
  MOST_RERUN_DECK: 'most_rerun_deck',
  QUIZ_MOMENTS: 'quiz_moments',
  TOTAL_REACTIONS: 'total_reactions',
  FAVOURITE_SLIDE_TYPE: 'favourite_slide_type',
  HIGHEST_AUDIENCE: 'highest_audience',
  BUSIEST_MONTH: 'busiest_month',
  YEAR_IN_ONE_LINE: 'year_in_one_line',
}

export const CHARACTER_KEYS = [
  'heart_stealer', 'plot_twister', 'energy_booster', 'showstopper', 'creative_chameleon', 'quiz_wizard', 'spark_starter',
]

export const SLIDE_DURATION_MS = 6000
